import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import { useApp } from '../context/AppContext';

export default function OfflineBanner() {
  const { lang } = useApp();
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  if (online) return null;
  return (
    <div className="fixed top-3 left-1/2 -translate-x-1/2 z-50 px-3 py-1.5 rounded-full bg-amber-500/20 border border-amber-400/40 text-amber-100 text-xs flex items-center gap-2 backdrop-blur shadow-lg">
      <WifiOff size={14} />
      {lang === 'fr' ? 'Mode hors-ligne — seules les chansons déjà écoutées restent disponibles' : 'Offline mode — only already-played songs remain available'}
    </div>
  );
}
